import { isChrome, isDesktop, isFirefox, isSafari } from './browser-detect';
import { TrelloWindow } from '@trello/window-types';
declare const window: TrelloWindow;

export function isEmbeddedDocument(): boolean {
  // When we run in Cypress, the header is hidden because Trello is running in an iframe.
  // We want to override this behavior so that the header is always shown when running in Cypress.
  const runsInCypress: boolean = window.Cypress !== undefined;
  return window.top !== window.self && !runsInCypress;
}

export const isTabActive = (): boolean =>
  document.visibilityState === 'visible';

export const isHighDPI = (): boolean => window.devicePixelRatio > 1;

export const supportsDynamicFavicon = (): boolean => isChrome() || isFirefox();

export const supportsFancyPeel = (): boolean =>
  isChrome() || isFirefox() || isSafari();

export const isEmbeddedInMSTeams = (): boolean => {
  if (!isEmbeddedDocument()) {
    return false;
  }

  const search = new URLSearchParams(window.location.search);
  return search.has('iframeSource') && search.get('iframeSource') === 'msteams';
};

export const dontUpsell = (): boolean => isDesktop() || isEmbeddedInMSTeams();
